<template>
  <div id="container" class="mainBox">
    <!-- 使用 vue-baidu-map-3x 提供的 BaiduMap 组件 -->
    <nyTit pathUrl="/farmlandIrrigationDisplay" />
    <h5 class="h5">高标农田展示系统</h5>
    <div class="content">
      <!-- 左 -->
      <div class="left">
        <div class="subTit1"><span>上蔡县高标准农田建设情况</span></div>
        <div class="left_top">
          <div class="left_top_left" v-html="state.leftTxt"></div>
          <div class="echarts"><LeftPie/>></div>
        </div>
        <div class="left_bottom" ><img src="../assets/img/nongye1/dt1.png" /> </div>
      </div>
      <!-- 中 -->
      <div class="middle">
<!--        <h5></h5>-->
        <div class="videoBox" v-if="AccessToken!=''">
          <div style="width: 100%;height: 100%">
            <vue3VideoPlay  id="video" ref="videoRef" width="100%" height="100%" title="视频监控" :poster="state.options.poster" :src="state.options.src" :type="state.options.type" :autoPlay="false" :muted="true" :control="false" />
          </div>
        </div>
      </div>

      <!-- 右 -->
      <div class="right">
        <div class="right-col">
          <div class="subTit2"><span>全县全域农作物生长状态监测</span></div>
          <GrowthStatusMonitor />
        </div>
        <div class="right-col">
          <div class="subTit2"><span>全县全域农作物产量预测</span></div>
          <YieldForecast />
          <div class="subTit2 warning-title" style="margin-bottom: 0;"><span>产量预警数据</span></div>
          <YieldWarningData />
        </div>
      </div>

    </div>

  </div>
<!--  <div class="footer">本产品由来村网提供技术支持</div>-->
</template>

<script setup>
// @ is an alias to /src
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import Gep from "../utils/范围面.json";
import axios from "axios";
import { useRouter } from "vue-router";
import nyTit from "@/components/nyTit.vue";
import LeftPie from "@/components/nonbye1/LeftPie";
import GrowthStatusMonitor from "@/components/gaobiaoFarmlandDisplay/GrowthStatusMonitor.vue";
import YieldForecast from "@/components/gaobiaoFarmlandDisplay/YieldForecast.vue";
import YieldWarningData from "@/components/gaobiaoFarmlandDisplay/YieldWarningData.vue";
import {
  reactive,
  toRefs,
  ref,
  onMounted,
  onUnmounted,
  computed,
  onBeforeUnmount,
  getCurrentInstance,
  defineEmits,
} from "vue";


// const timer = ref(null);
const router = useRouter();
const mapRef = ref(null);
const state = reactive({
  leftTxt:" 上蔡县坚决贯彻落实习近平总书记关于耕地保护、粮食安全是“国之大者”的重要论述，按照新形势下国家粮食安全和农业可持续发展的总体要求，深入贯彻落实“藏粮于地、藏粮于技”战略，以推进农业现代化为目标，以促进农业可持续发展为主线，强力推动高标准农田建设，改善农业生产条件，提高农业特别是粮食综合生产能力。截至目前，全县已建成高标准农田150.41万亩，2024年再建成11万亩，确保实现全县耕地高标准农田全覆盖。",
  options: {
    // src: "https://lcamapp.oss-cn-beijing.aliyuncs.com/video/video/nongye/liangan.mp4",
    src: "https://lcamapp.oss-cn-beijing.aliyuncs.com/video/video/nongye/liangtianqianqin11.mp4",
    type: "video/mp4", //视频类型
    poster: require('../assets/img/nongye1/video_fm_ny.jpg'),
  },
  AccessToken:"",
  rightTxt:"  上蔡县5万亩高标准农田示范区项目，位于上蔡县西南部，与遂平县5万亩高效节水灌溉示范区相连成片。以高效、节水、智能、绿色、生态为建设目标，将物联网、大数据、云计算与喷灌智能控制系统有机融合，特别是利用北汝河地表水进行灌溉，更符合高效节水灌溉建设要求。项目建成后，将成为一流的物联网、智能化的高效节水灌溉示范区，真正实现“藏粮于地、藏粮于技”，对提高全县农业基础设施建设水平，加快现代农业发展，促进乡村振兴具有重要意义。",
  rightData2:[{name:"新增节水灌溉面积",value:5,unit:"万亩"},{name:"辐射带动周边应用高效节水灌溉面积",value:10,unit:"万亩以上"}],
  rightData3:[
    {
      name:"生态效益",
      list:[
        {name:"灌溉用水保证率",value:"≥95%"},
        {name:"农田林网覆盖率",value:"≥95%"},
        {name:"土壤有机质含量提高",value:"0.5%"},
        {name:"减少农药化肥使用量",value:"20%"},
      ]
    },{
      name:"经济效益",
      list:[
        {name:"每年新增粮食",value:"250万公斤"},
        {name:"每年新增油料",value:"150万公斤"},
        {name:"直接增加经济效益",value:"1525万元"},
        {name:"辐射区粮油效益增加",value:"2000万元以上"},
      ]
    },{
      name:"社会效益",
      list:[
        {name:"直接受益农户",value:"8333户"},
        {name:"年均纯收入增加",value:"1830元"},
        {name:"间接受益农户",value:"1.6万户以上"},
        {name:"年均纯收入增加",value:"1200元以上"},
      ]
    }
  ]
});







// 地图底图


// 在 onMounted 中初始化地图
onMounted(() => {
  state.AccessToken = localStorage.getItem('AccessToken')


});


onUnmounted(() => {


});
onBeforeUnmount(() => {
  // clearInterval(timer.value);
});

</script>
<style lang="less" scoped>
.footer {
  width: 100%;
  height: 30px;
  line-height: 30px;
  color: #fff;
  text-align: center;
  font-size: 30px;
  position: fixed;
  bottom: 30px;
  left: 0;
  z-index: 10000;
  font-weight: bold;

}

body {
  background-size: cover;
  line-height: 1.15;
}

.h5{
  position: absolute;
  top: 150px;
  left: 100px;
  z-index: 999;
  font-size: 40px;
  color:#F3FCFF;
  letter-spacing: 5px;
  text-align: left;
  //text-shadow: 5px 0px 5px rgba(13, 89, 82, .9)
  text-shadow:
    0 0 5px rgba(21, 241, 187, 0.5), /* 第一层内发光 */
    0 0 10px rgba(21, 241, 187, 0.8), /* 第二层内发光 */
    0 0 20px rgba(21, 241, 187, 1);   /* 第三层内发光 */
}
.mainBox {
  width: 100%;
  height: 100%;
  position: absolute;
  overflow: hidden;
  background: url("../assets/img/plantmoxing/new/bj.png") no-repeat top center;
  background-size: 100% 100%;

  .content {
    width: 100%;
    height: calc(100% - 150px);
    position: absolute;
    top: 150px;
    // border: #fff 1px solid;
    display: flex;
    padding: 0 30px 100px;
    .subTit1{
      width: 100%;
      height: 130px;
      line-height: 40px;
      background: url("../assets/img/nongye1/bt.png") no-repeat center bottom;
      color: #fff;
      font-size: 40px;
      margin: 20px auto 0;
      span{
        background: linear-gradient(to bottom, #fff 25%, #FFD791 95%);
        background-clip: text;
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        font-weight: bold;


      }
    }
    .subTit2 {
      width: 100%;
      height: 66px;
      line-height: 20px;
      padding-left: 40px;
      margin-bottom: 30px;
      box-sizing: border-box;
      background: url("https://lcamapp.oss-cn-beijing.aliyuncs.com/uploads/img/img/xiaomai/xbt.png") no-repeat left bottom;
      font-size: 30px;
      text-align: left;
      color: rgba(254, 254, 254, 1);
    }
    .left{
      width: 2175px;
      height: 100%;
      display: flex;
      flex-direction: column;
      .left_top{
        width: 100%;
        flex: 1;
        display: flex;
        .left_top_left{
          width: 1062px;
          height: 90%;
          color: #CEF6FE;
          font-size: 30px;
          padding-left: 100px;
          text-align: left;
          line-height: 56px;
          text-indent: 2em;
        }
        .echarts{
          height: 100%;
          flex: 1;
        }
      }
      .left_bottom{
        height: 624px;
      }
    }
    .middle{
      flex: 1;
      height: 100%;
     padding-top: 50px;
      display: flex;
      flex-direction: column;
      h5{
        font-size: 50px;
        color:#F3FCFF;
        letter-spacing: 5px;
        //text-shadow: 5px 0px 5px rgba(13, 89, 82, .9)
        text-shadow:
          0 0 10px rgba(21, 241, 187, 0.5), /* 第一层内发光 */
          0 0 20px rgba(21, 241, 187, 0.8), /* 第二层内发光 */
          0 0 30px rgba(21, 241, 187, 1);   /* 第三层内发光 */
      }
      .videoBox{
        width: 100%;
        flex: 1;
        background: url("../assets/img/nongye1/spk.png") no-repeat;
        padding: 20px;
        background-size: 100% 100%;
        margin-top: 30px;
      }

    }
    .right{
      width: 2024px;
      height: 100%;
      display: grid;
      grid-template-columns: repeat(2, minmax(0, 1fr));
      gap: 58px;
      padding-left: 58px;
      box-sizing: border-box;

      .right-col {
        min-width: 0;
        min-height: 0;
        display: flex;
        flex-direction: column;
      }

      .warning-title {
        margin-top: 34px;
      }

    }







    }




}

@keyframes guangying {
  /*引用动画名称*/
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(-360deg);
  }
}

@keyframes left1Img {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.2);
  }
  100% {
    transform: scale(1);
  }
}

@keyframes titIcon {
  /*引用动画名称*/
  0% {
    transform: rotateY(0);
  }
  50% {
    transform: rotateY(180deg);
    animation-delay: 5s;
  }
  100% {
    transform: rotateY(0);
  }
}
</style>
